import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = no, obj = yes
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rb_token");
    if (!token) {
      setAdmin(false);
      setLoading(false);
      return;
    }
    api
      .me()
      .then((u) => setAdmin(u))
      .catch(() => {
        localStorage.removeItem("rb_token");
        setAdmin(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.login({ email, password });
    localStorage.setItem("rb_token", res.token);
    setAdmin(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem("rb_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
